import { IAnalyticsService } from './ianalyticsservice';

export const NoOpAnalyticsService: IAnalyticsService = {
  recordEvent(eventType: string, eventData: object): void {
    /* do nothing */
  },
  recordError(error: any): void {
    /* do nothing */
  },
};
